/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { run } from './Ballistic';

window.addEventListener('WebComponentsReady', () => {
  run(document.getElementById('viewer'));
  document.getElementById('gui').style.display = 'block';
});
